<template lang="pug">
  footer#footer.footer.navbar.is-fixed-bottom
    ul.footer_nav
      li.footer_navItem
        router-link.footer_navLink(to="/") Home
    .copy Lossti.me&copy;2019

</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style scoped lang="stylus">
#footer
  display: block!important
  padding: 0!important
  background-color: #FFF
  .footer_nav
    display: flex
    flex-direction: row
    justify-content: center
    .footer_navItem
      display: block
      margin-right: 0.5rem
      margin-left: 0.5rem
      .footer_navLink
        lihe-height: 2em
        font-size: 0.8rem
      &.secret
        opacity: 0
  .copy
    text-align: center
    line-height: 1.7em
    font-size: 0.8rem
    margin-bottom: 7px
</style>
